import styled from '@emotion/styled';
import Popover from '@mui/material/Popover';

import {
  blueBlack640,
  blueBlack950,
  white,
} from '../../../../theme/videa-style-tokens';

export const Shortcuts = styled.div`
  display: flex;
  position: relative;
  width: 2em;
  height: 1.4em;

  .keyboard-icon {
    width: 2em;
    height: 1.4em;
  }

  .throb {
    display: inline-block;
    position: absolute;
    top: 0;
    right: -0.125em;
    background: black;
    border-radius: 50%;
    box-shadow: 0 0 0 0.25em rgba(0, 0, 0, 1);
    height: 0.5em;
    width: 0.5em;
    transform: scale(1);
    animation: pulse-black 2s 10;
    background: rgba(157, 185, 255, 1);
    box-shadow: 0 0 0 0 rgba(157, 185, 255, 1);
    animation: pulse-blue 2s 10;
    z-index: 1;
  }

  @keyframes pulse-blue {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(157, 185, 255, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(157, 185, 255, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(157, 185, 255, 0);
    }
  }
`;

export const Pop = styled(Popover)`
  .MuiPopover-root {
    padding: 1em;
    transform: translateY(-2em);
  }
  .MuiPopover-paper {
    font-size: 0.8em;
    background-color: ${blueBlack640};
    color: white;
    padding: .5em;
  }
  .title {
    font-weight: bold;
  }
  .key {
    display: inline-block;
    padding: .125em;
    background-color: ${blueBlack950};
    color: ${white};
    border-radius: .25em;
    width: 1.5em;
    text-align: center;
    height: 1.5em;
    margin-right: .5em;
`;
